export default __webpack_public_path__ + "static/media/wallet-connect.70fb9e0f.webp";